// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Offer40FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Offer40Filled: FC<Offer40FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="M18.604 36.667c-.361 0-.718-.065-1.07-.195a2.345 2.345 0 0 1-.916-.61l-12.472-12.5a2.431 2.431 0 0 1-.618-.91 2.855 2.855 0 0 1-.202-1.035c0-.343.068-.69.202-1.042.134-.352.34-.667.618-.945l15.25-15.263c.25-.25.55-.452.902-.605.353-.152.714-.229 1.084-.229h12.514c.768 0 1.423.271 1.965.813.542.541.813 1.197.813 1.965v12.486c0 .37-.075.725-.223 1.063a2.856 2.856 0 0 1-.597.882l-15.292 15.32c-.259.277-.564.48-.916.61-.352.13-.7.195-1.042.195Zm10.986-24a2.19 2.19 0 0 0 1.604-.674 2.19 2.19 0 0 0 .674-1.604 2.19 2.19 0 0 0-.674-1.604 2.191 2.191 0 0 0-1.604-.674c-.62 0-1.155.225-1.604.673a2.19 2.19 0 0 0-.674 1.605c0 .62.225 1.155.674 1.604.45.449.984.674 1.604.674Z" />
        </svg>
    );
};

export default Offer40Filled;
